import React, { useState } from 'react'
import {
  makeStyles,
  createStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  Divider,
} from '@material-ui/core'
import { throttle } from 'lodash'
import { useTranslation } from 'react-i18next'
import { ReactComponent as VectorIcon } from 'src/mobile/assets/icons/Home_Vector.svg'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
    paper: {
      minWidth: 295,
    },
    titleWrapper: {
      paddingTop: theme.spacing(2.5),
      backgroundColor: 'transparent',
      color: theme.palette.grey[900],
    },
    title: {
      fontWeight: 600,
      fontSize: 18,
    },
    button: {
      height: theme.spacing(5.25),
      padding: 0,
      '& path': {
        fill: theme.palette.primary.contrastText,
      },
    },
    actionRoot: {
      paddingBottom: theme.spacing(2.5),
    },
    actionRoot2: {
      flexDirection: 'column-reverse',

      paddingBottom: theme.spacing(2.5),
    },
    actionSpacing: {
      '&>:not(:first-child)': {
        marginLeft: theme.spacing(2),
      },
    },
    actionSpacing2: {
      '&>:not(:first-child)': {
        marginLeft: theme.spacing(0),
      },
    },
    backdrop: {
      zIndex: 1300 + 1000,
      color: '#fff',
    },
  }),
)

const EDialog = ({
  children,
  trigger,
  title,
  loading,
  onConfirm,
  onCancel,
  tutorialDialog,
  updateBooking,
  noAction,
}) => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [status, setStatus] = useState('')
  const { t } = useTranslation()
  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    if (status === 'pending' && loading) return
    setOpen(false)
  }

  const _onConfirm = throttle(async (e) => {
    e.preventDefault()
    if (status === 'pending' && loading) return
    try {
      setStatus('pending')
      await onConfirm?.()
      setStatus('fulfilled')
      // handleClose()
    } catch (error) {
      console.log('Confirm fail:', error)
      setStatus('rejected')
    }
  }, 1000)

  const _onCancel = () => {
    onCancel?.()
    handleClose()
  }

  return (
    <>
      <Box flexShrink={0} onClick={handleClickOpen}>
        {trigger}
      </Box>
      <Dialog
        classes={{
          paper: classes.paper,
        }}
        className={classes.root}
        open={open}
        onClose={_onCancel}
      >
        <DialogTitle className={classes.titleWrapper} disableTypography>
          <Typography className={classes.title} align="center" variant="h4" color="initial">
            {title}
          </Typography>
        </DialogTitle>
        {(updateBooking || noAction) && <Divider />}
        {children && <DialogContent>{children}</DialogContent>}
        {!updateBooking && !noAction && (
          <DialogActions
            classes={{
              root: classes.actionRoot,
              spacing: classes.actionSpacing,
            }}
          >
            {!tutorialDialog && (
              <Button
                fullWidth
                className={classes.button}
                onClick={_onCancel}
                variant="outlined"
                color="primary"
                disabled={status === 'pending' && loading}
              >
                {tutorialDialog ? t('common.cancel') : t('common.back')}
              </Button>
            )}
            <Button
              fullWidth={!tutorialDialog}
              className={classes.button}
              onClick={_onConfirm}
              variant="contained"
              color={tutorialDialog ? 'primary' : 'secondary'}
              disabled={status === 'pending' && loading}
            >
              {status === 'pending' && loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : tutorialDialog ? (
                t('common.leave')
              ) : (
                t('common.confirm')
              )}
            </Button>
          </DialogActions>
        )}
        {updateBooking && (
          <DialogActions
            classes={{
              root: classes.actionRoot2,
              spacing: classes.actionSpacing2,
            }}
          >
            <Button
              fullWidth
              className={classes.button}
              onClick={_onCancel}
              variant="outlined"
              color="primary"
              disabled={status === 'pending' && loading}
            >
              {t('common.back')}
            </Button>
            <Button
              fullWidth
              className={classes.button}
              onClick={_onConfirm}
              variant="contained"
              color="secondary"
              style={{ marginBottom: '8px' }}
              disabled={status === 'pending' && loading}
            >
              <VectorIcon />{' '}
              <Box display="inline-block" ml={1}>
                {t('footer.whatsapp')}
              </Box>
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </>
  )
}

export default EDialog
